module.exports = __webpack_public_path__ + "static/fonts/Fact-BlackItalic.799a409.eot";